import React from 'react';

const AiVideoGeneratorFormModal = React.lazy(() => import('../components/FormModal'));
const aiVideoGeneratorModalRegistry = {
    aitools_aiVideoGenerator: AiVideoGeneratorFormModal
};
export default aiVideoGeneratorModalRegistry;
